import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "ma-0",
    flat: ""
  }, {
    default: _withCtx(() => [
      (_ctx.order)
        ? (_openBlock(), _createBlock(_component_v_card_text, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { col: "6" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        modelValue: _ctx.order.date,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.order.date) = $event)),
                        label: "Date",
                        variant: "outlined",
                        density: "comfortable",
                        dense: "",
                        type: "date",
                        color: "primary"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_v_text_field, {
                        modelValue: _ctx.order.time,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.order.time) = $event)),
                        label: "Time",
                        variant: "outlined",
                        density: "comfortable",
                        dense: "",
                        type: "time",
                        color: "primary"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_v_text_field, {
                        modelValue: _ctx.order.visitNumber,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.order.visitNumber) = $event)),
                        label: "Visit",
                        variant: "outlined",
                        density: "comfortable",
                        dense: "",
                        color: "primary"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_v_autocomplete, {
                        modelValue: _ctx.order.type,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.order.type) = $event)),
                        label: "Type",
                        items: _ctx.orderTypeItems,
                        variant: "outlined",
                        density: "comfortable",
                        color: "primary"
                      }, null, 8, ["modelValue", "items"]),
                      _createVNode(_component_v_text_field, {
                        modelValue: _ctx.order.description,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.order.description) = $event)),
                        label: "Description",
                        variant: "outlined",
                        density: "comfortable",
                        dense: "",
                        color: "primary"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}